import api from './api'
import apiDecrypt from './api-decrypt'
import apiNoLogin from './api-no-login'
import apiNodeRed from './api-nodered'
import gql from './gql'
import mqtt from './mqtt'

export default { api, apiNoLogin, gql, mqtt, apiNodeRed, apiDecrypt }
